import React, { useEffect, useMemo, useState } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import { useTranslation } from './TranslationProvider';
export const withTranslation = (WrappedComponent, secondaryLabelsPath) => {
    const Enhance = (props) => {
        const { labels: primaryLabels } = props;
        const [secondaryLabels] = useState(() => reduce(secondaryLabelsPath, (acc, curr) => ({
            ...acc,
            ...get(props, curr, null),
        }), {}));
        const { addToDictionary, isInitialized } = useTranslation();
        const labels = useMemo(() => ({
            ...primaryLabels,
            ...secondaryLabels,
        }), [primaryLabels, secondaryLabels]);
        useEffect(() => {
            if (isInitialized) {
                addToDictionary(labels);
            }
        }, [addToDictionary, isInitialized, labels]);
        return React.createElement(WrappedComponent, { ...props });
    };
    hoistNonReactStatic(Enhance, WrappedComponent);
    return Enhance;
};
